export default __webpack_public_path__ + "static/media/waitlist-calendar.1f6fe993.svg";